import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tourServices } from '../services/tour.service';
import toast from 'react-hot-toast';

export const useDeleteTour = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: tourServices.deleteTour,
    onSuccess: (data) => {
      toast.success(data.message || 'Tour deleted successfully');
      queryClient.invalidateQueries({ queryKey: ['tours'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete tour');
    },
  });
};
